export default [
  [`Размеры`, `5XS`, `4XS`, `3XS`, `2XS`, `XS`, `S`],
  [`Плечи`, `26`, `33`, `35`, `38`, `40`, `41`],
  [`Грудь`, `30`, `34`, `37`, `40`, `42`, `46`],
  [`Длина`, `41`, `46`, `52`, `56`, `59`, `60`],
  [
    `Возрастная группа`,
    `4-5 лет`,
    `6-7 лет`,
    `7-8 лет`,
    `8-9 лет`,
    `10-11 лет`,
    `12-14 лет`
  ]
];
